import { customElement, GenesisElement } from '@genesislcap/web-core';
import { UserActivityStyles as styles } from './user-activity.styles';
import { UserActivityTemplate as template } from './user-activity.template';
import { getUserManagementColumns, getUserSessionColumns } from './user-activity.columns';

@customElement({
  name: 'user-activity-route',
  template,
  styles,
})
export class UserActivityRoute extends GenesisElement {
  get userManagementGridOptions() {
    return {
      columnDefs: getUserManagementColumns(),
    };
  }

  get userSessionGridOptions() {
    return {
      columnDefs: getUserSessionColumns(),
    };
  }
}

